/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';
import template from './setup-settings.html';

// TODO Univerzální komponenta `FormField`. Nyní se kód opakuje.
export default {
  name: 'SetupSettings',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
  },
  directives: { focus },
  data() {
    return {
      field: {
        serverUrl: {
          label: 'Server URL',
          validator: {
            required: true,
            url: { require_tld: false }
          },
          value: this.serverUrl
        }
      }
    };
  },
  methods: {
    handleError(error) {
      this.$root.logger.error(error);
    },
    onBack() {
      this.$emit('back');
    },
    onChange() {
      new Promise((resolve) => {
        if (!this.submitted) {
          return resolve();
        }
        return resolve(this.$validator.validateAll());
      }).catch((error) => this.handleError(error));
    },
    onReset() {
      this.field.serverUrl.value = this.defaultServerUrl;
    },
    onSubmit() {
      new Promise((resolve) => {
        this.submitted = true;
        return resolve(this.$validator.validateAll());
      })
        .then((valid) => {
          if (!valid) {
            return;
          }
          this.$emit('submit', this.field.serverUrl.value);
        })
        .catch((error) => this.handleError(error));
    }
  },
  props: ['defaultServerUrl', 'isOnline', 'serverUrl']
};
